var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3287 14L21.3287 3M10.3287 14L13.8287 21C13.8726 21.0957 13.943 21.1769 14.0316 21.2338C14.1203 21.2906 14.2234 21.3209 14.3287 21.3209C14.434 21.3209 14.5371 21.2906 14.6257 21.2338C14.7144 21.1769 14.7848 21.0957 14.8287 21L21.3287 3M10.3287 14L3.32868 10.5C3.23294 10.4561 3.15181 10.3857 3.09493 10.2971C3.03805 10.2084 3.00781 10.1053 3.00781 10C3.00781 9.89468 3.03805 9.79158 3.09493 9.70295C3.15181 9.61431 3.23294 9.54387 3.32868 9.5L21.3287 3",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.3bd1637bb44e4e973fcc3c9848c758f7.svg";
export { ForwardRef as ReactComponent };